import type { Product } from '../../../../data/product';
import type { FamilyTotals } from '../utils/family-aggregates';
import type { ProductOrderItem } from './product-order-item';

export const UNASSIGNED_FAMILY_ID = '__unassigned';

export type Family = {
  /** Body-only key — two products with the same body are in the same group. */
  id: string;
  /** Majority brand | majority description (size_ounces tiebreak). */
  name: string;
  /** Majority brand among the members (the brand half of `name`). */
  brand: string;
  /** Members ordered by size_ounces descending, item_code tiebreak. */
  members: ProductOrderItem[];
  /** Candidates for adding to this family. */
  candidates: Product[];
  /** Committed-allocation rollup; recomputed on each useFamilies pass. */
  totals: FamilyTotals;
  /** Forward-looking 90d savings score; drives default sort order. */
  expectedSavings90d: number;
};
